<template>
	<div class="fixed-text" id="fixed-text" ref="viewRef">
		<template v-if="text">
			<div v-if="!showTooltip" class="fixed-text-content" ref="contentRef" :style="{ textAlign: align }">
				{{ text }}
			</div>
			<el-tooltip
				v-else
				:popper-class="`fixed-text-popper ${popperClass}`"
				class="item"
				effect="dark"
				:content="content || text"
				:placement="placement"
			>
				<template v-if="$slots.content" slot="content">
					<slot name="content"></slot>
				</template>
				<span v-else slot="content">
					{{ text }}
				</span>
				<div class="whitespace-nowrap" :style="{ textAlign: align }">
					{{ text }}
				</div>
			</el-tooltip>
		</template>

		<div v-else :style="{ textAlign: align }">{{ text || "-" }}</div>
	</div>
</template>

<script>
/**
 * 定宽文本组件（超出给定宽度时以Tooltip显示）
 * @param {String} text - 显示文本
 * @param {String} placement - tooltip显示位置
 * @param {String} content - tooltip显示内容，不传时显示text内容
 * @param {String} align - 文本对齐方式（left/center/right）
 */
export default {
	name: "FixedText",
	props: {
		/**
		 * 显示文本
		 */
		text: {
			type: [String, Number],
			default: "",
			required: true
		},
		/**
		 * tooltip显示位置
		 */
		placement: {
			type: String,
			default: "top"
		},
		/**
		 * tooltip显示内容
		 */
		content: {
			type: String
		},
		/**
		 * 文本对齐方式
		 */
		align: {
			type: String,
			default: "left"
		},
		popperClass: {
			type: String
		}
	},
	data() {
		return {
			showTooltip: false
		};
	},
	methods: {
		setTooltip() {
			this.showTooltip = false;

			this.$nextTick(() => {
				if (this.$refs.contentRef) {
					const viewWidth = this.$refs.viewRef.offsetWidth;
					const contentWidth = this.$refs.contentRef.scrollWidth;

					// 如果内容宽度大于视图宽度，显示tooltip
					if (contentWidth > viewWidth) {
						this.showTooltip = true;
					}
				}
			});
		}
	},
	computed: {
		hasSlot() {
			return Boolean(this.$slots.default);
		},
		textAlign() {
			if (this.align === "center") {
				return "center";
			}

			if (this.align === "right") {
				return "flex-end";
			}

			return "flex-start";
		}
	},
	mounted() {
		this.setTooltip();
	},
	watch: {
		text() {
			this.setTooltip();
		}
	}
};
</script>

<style lang="scss" scoped>
.fixed-text {
	max-width: 100%;

	&-content {
		min-width: 0;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
}

.whitespace-nowrap {
	min-width: 0;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
</style>

<style lang="scss">
.fixed-text-popper {
	max-width: 250px;
}
</style>
